import { observer } from 'mobx-react';
import * as React from 'react';
import { findLinkBy } from '../../../../../../../Fetch';
import { Link } from '../../../../../../../Resource/Types';
import { T } from '../../../../../../../Translations';
import DownloadIcon from '../../../../../../Cutesies/DownloadIcon';
import ExternalLink from '../../../../../../ExternalLink';
import { emptyFragment } from '../../../../../../../EmptyFragment';

export interface Props {
  links: ReadonlyArray<Link>;
}

const OverviewPdfLink: React.FC<Props> = ({ links }) =>
  findLinkBy({ rel: 'download-overview-pdf' }, links)
    .map((link) => (
      <ExternalLink href={link.href}>
        <div className="ml-4 flex text-sm">
          <span className="mr-3">
            <T kind="View full details" />
          </span>
          <span className="flex items-center">
            <DownloadIcon />
          </span>
        </div>
      </ExternalLink>
    ))
    .getOrElse(emptyFragment);

export default observer(OverviewPdfLink);
